<template>
  <v-card flat>
    <v-layout>
      <v-flex xs12 sm6>
        <v-list class="pt-0" dense>
          <template v-for="(partner, index) in AdvertExclusions">
            <v-divider v-if="index > 0" :key="index"></v-divider>
            <v-list-item :key="partner.id">
              <v-list-item-content>
                <v-list-item-title
                  v-text="partner.name"
                  style="max-width:250px;overflow: hidden;text-overflow: ellipsis"
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="includeAdvertPartner({ advertId: advert.id, partner })">
                  <v-icon color="red">fas fa-trash</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-autocomplete
        :items="PartnersList"
        item-text="name"
        item-value="id"
        v-model="selectedPartnerId"
        clearable
        placeholder="Select a partner to exclude"
        dense
        hide-details
        class="ml-3"
      ></v-autocomplete>
      <v-btn @click="excludePartner(selectedPartnerId)">Exclude</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'AdvertExclusions',
  props: ['advert'],
  data: () => ({
    selectedPartnerId: null
  }),
  computed: {
    ...mapGetters(['AdvertExclusions', 'PartnersList']),
    partners() {
      return this.PartnersList.map(partner => !this.AdvertExclusions.includes(partner));
    }
  },
  methods: {
    ...mapActions(['excludeAdvertPartner', 'getAdvertExclusions', 'getPartnersList', 'includeAdvertPartner']),
    excludePartner(partnerId) {
      const partner = _.clone(_.find(this.PartnersList, p => p.id === partnerId));
      const advertId = this.advert.id;
      this.excludeAdvertPartner({ advertId, partner });
    }
  },
  mounted() {
    this.getAdvertExclusions(this.advert);
    this.getPartnersList();
  }
};
</script>

<style scoped></style>
